import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@statsbomb/kitbag-components';
import { LocalSearchResult } from './LocalSearchResults.styles';

const LocalSearchResults = ({ results, handleResult }) => (
  <LocalSearchResult>
    {results?.map((result) => (
      <div className="result" key={result.id}>
        <Button
          variant="ghost"
          size="small"
          onClick={() => handleResult(result.id)}
        >
          {`${result.name} (${result.mostCommonPosition.code}) - ${result.team.shortName}`}
        </Button>
      </div>
    ))}
  </LocalSearchResult>
);

LocalSearchResults.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      mostCommonPosition: PropTypes.shape({
        code: PropTypes.string.isRequired,
      }).isRequired,
      team: PropTypes.shape({
        id: PropTypes.string.isRequired,
        shortName: PropTypes.string.isRequired,
        competition: PropTypes.shape({
          id: PropTypes.string,
        }),
      }).isRequired,
      season: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    })
  ),
  handleResult: PropTypes.func.isRequired,
};

LocalSearchResults.defaultProps = {
  results: [],
};

export default LocalSearchResults;
